import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function AuditorDocumentHRA() {
  return (
    <>
      <Helmet>
        <title> AuditorDocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Auditor-HRA"/>
      </Container>
    </>
  );
}
